import types from '../../actions/types';
import {paginatedResultReducer} from '../common/paginated_results';

const initialState = {
    loading: false
};

export default function usersReducer(state = initialState, action) {

    switch (action.type) {
        case types.ADMIN_LOAD_USER.REQUEST:
            return {
                ...state,
                user: {},
                loading: true
            };

        case types.ADMIN_LOAD_USER.SUCCESS:

            return {
                ...state,
                user: action.payload,
                loading: false
            };

        case types.SUBMIT_USER.SUCCESS:
            return {
                ...state,
                user: action.payload,
                loading: false
            };
        default:
            return {
                ...state,
                result: paginatedResultReducer(state.result, types.ADMIN_LOAD_USERS, action)
            };
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/admin/users.js